/**
 *  GENERAL CONSTANTS CONTROL CENTER
 *  In this file the general constants of the project are configured,
 *  any reusable constants in the ENTIRE project.
 *  In no constants file (except general) are constants of this type exported to the outside,
 *  the only thing that is returned is the JSON of constants (key, value) for the variable content.
 */
/* Icons for the subscription banner status */
import {
  faExclamationTriangle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

export const photoBgApiUrl = 'https://picsum.photos/1000';

export const COMPANY_INFORMATION = {
  nit: '900621633-1',
  address: 'Calle 40 #13-09 Oficina 1101 Bogotá DC - Código Postal 110231',
  phone: '+57 3105702751',
  url: 'https://edunext.co',
  email: 'contacto@edunext.co',
};

export const DEFAULT_MAX_SIZE_PAGINATION = 10;

/**
 * Default messages for the subscription banner status.
 *
 * This messages can be overriede if the field "Blocking Label"
 * in My Subscription > Backoffice section is provided.
 */
export const productMessageSubscriptionStatusMap = {
  NM: {
    status: 'NM', // Normal
    message: '',
    style: '',
  },
  OQ: {
    status: 'OQ', // Overquota
    message:
      'Your subscription has passed the allocated number of active users users!. Please perform modify your subscription to increase the capacity.',
    style: 'alert-warning',
    iconStyle: 'me-2 text-warning',
    icon: faExclamationTriangle,
  },
  BOQ: {
    status: 'BOQ', // Blocked Overquota
    message:
      'Your subscription has been blocked for surpassing the allocated number of active users!. Please reach out to the edunext team for assistance!',
    style: 'alert-danger',
    iconStyle: 'me-2 text-danger',
    icon: faExclamationCircle,
  },
  PA: {
    status: 'PA', // Payment Alert
    message:
      'Your subscription payment is overdue. Make sure that pending payments are processed at the earliest convenience!',
    style: 'alert-warning',
    iconStyle: 'me-2 text-warning',
    icon: faExclamationTriangle,
  },
  PS: {
    status: 'PS', // Payment SoftBlock
    message:
      'Your subscription payment is overdue. Learners and authors are still able to access the platform, but urgent action is needed to prevent the interruption of service!',
    style: 'alert-warning',
    iconStyle: 'me-2 text-warning',
    icon: faExclamationTriangle,
  },
  PH: {
    status: 'PH', // Payment Hardblock
    message:
      'Your subscription payment is overdue. Learners and authors are no longer able to access the platform. Contact the edunext team to have your subscription reactivated!',
    style: 'alert-danger',
    iconStyle: 'me-2 text-danger',
    icon: faExclamationCircle,
  },
  PC: {
    status: 'PC', // Pending contract
    message:
      'Your subscription pending on some administrative processed. Learners and authors are still able to access the platform, but urgent action is needed to prevent the interruption of service!',
    style: 'alert-warning',
    iconStyle: 'me-2 text-warning',
    icon: faExclamationTriangle,
  },
  BP: {
    status: 'BP', // Blocked permant
    message:
      'Your subscription is permanently blocked. Contact the edunext team for more info.',
    style: 'alert-danger',
    iconStyle: 'me-2 text-danger',
    icon: faExclamationCircle,
  },
  SP: {
    status: 'SP', // Suspend
    message: 'Your subscription is suspended.',
    style: 'alert-danger',
    iconStyle: 'me-2 text-danger',
    icon: faExclamationCircle,
  },
  PB: {
    status: 'PB', // Probono
    message: '',
    style: '',
  },
};

export const maxFileSize = 1000000; // 1mb

export const imageFileTypes = [
  'image/apng',
  'image/avif',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/webp',
  'image/vnd.microsoft.icon',
];

export const attributeStatusTagColors = {
  planned: '#2db7f5',
  active: '#00D47D',
  merged: '#5C718B',
  in_maintenance: '#FBCC07',
  in_development: '#960AFFA1',
  removed: 'error',
};

export const imgNotFoundBase64 = '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';

export const edunextLogoFileByColor = {
  color: 'https://d1uwn6yupg8lfo.cloudfront.net/edxsites/bragi-images/logo-small21.png',
  dark: 'https://d1uwn6yupg8lfo.cloudfront.net/edxsites/bragi-images/logo-small21-dark.png',
  light: 'https://d1uwn6yupg8lfo.cloudfront.net/edxsites/bragi-images/logo-small21-light.png',
};

export const openedxLogoByColor = {
  color: 'https://files.edx.org/openedx-logos/edx-openedx-logo-tag.png',
  dark: 'https://files.edx.org/openedx-logos/edx-openedx-logo-tag-dark.png',
  light: 'https://files.edx.org/openedx-logos/edx-openedx-logo-tag-light.png',
};

export const SERVICE_ERROR_MESSAGES = {
  400: {
    title: 'Oops! Something went wrong.',
    message: 'We could not save your changes because some fields contain errors. Please review and correct them.',
    onlyNotification: true,
  },
  404: {
    title: 'Oops! Some configuration details are missing.',
    message: "We couldn't find all the necessary settings for this site to allow the display of this interface. Please request assistance from support.",
    discardChanges: true,
    tryAgain: true,
  },
  500: {
    title: 'Oops! Our servers are having problems.',
    message: "We're sorry, but there was an internal error. Please try again later. If you're still having trouble, let us know and we'll be happy to help.",
    discardChanges: true,
    tryAgain: true,
  },
};

export const DEFAULT_RESIZE_IMG_UPLOAD_DIMENSIONS = {
  width: 400,
  height: 400,
};
